import { render, staticRenderFns } from "./cube-page.vue?vue&type=template&id=501b7be9"
import script from "./cube-page.vue?vue&type=script&lang=js"
export * from "./cube-page.vue?vue&type=script&lang=js"
import style0 from "./cube-page.vue?vue&type=style&index=0&id=501b7be9&prod&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports